import React from 'react';
import {default as CloseErrorIcon} from "../../icons/CloseError";
import styled from "styled-components";

export default function() {
  return (
    <Container>
      <div>
        <CloseErrorIcon />
        <p style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0 }}>
          An error occurred while loading the report data.
        </p>
        <p style={{ margin: 0 }}>
          Please contact Digital Solutions (digitalsolutions@valentino.com) if
          the error persist
        </p>
      </div>
    </Container>
  );
}

const Container = styled.div`
  padding-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 12rem;
  }

  p {
    text-align: center;
  }

  > div > svg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 4rem;
    height: 4rem;
  }
`;
